import React from "react";
import Header from "../header/header";
import HeaderImageSection from "../shared/headerImageSection";
import FooterComponent from "../footerComponent/footerComponent";
import qr from "../../assets/header/qrCode.png";

const Terms = () => {
  return (
    <>
      <Header />
      <HeaderImageSection />
      <section className="p-4 container mt-4 bgAntiFlashWhite">
        <label className="headerLabel">Terms & Conditions</label>
        <div className="bg-white p-2 row mb-3">
          <div className="col mb-3">
            <h1 className="font18px font-bold mb-1">
              कुंभार मंगलम वधुवर केंद्र”
            </h1>
            <h1 className="font18px mb-1">
              (कुंभार समाजासाठी महाराष्ट्रातील अग्रणी विवाह संस्था)
            </h1>
          </div>
          <div className="col mb-3">
            <h1 className="font18px mb-1">
              <span className="font-bold">पत्ता :</span> दरेकर चोरडिया कॉम्प्लेक्स
            </h1>
            <h1 className="font18px mb-4">
              पंड़ित पेट्रोल पंप समोर इन्फोसिस रोड, ताथवडे पुणे ३३
            </h1>
            <h1 className="font18px mb-1">
            <span className="font-bold">मोबाईल :</span> 9272183132 / 8888339175
            </h1>
            <h1 className="font18px mb-1">
            <span className="font-bold">ईमेल :</span> kumbharmangalaam@gmail.com
            </h1>
            <h1 className="font18px">
              कामकाजाची वेळ : सकाळी १० ते सायं ६
            </h1>
          </div>
        </div>
        <h1 className="font22px font-bold mb-1">केंद्राची प्रमुख वैशिष्ट्ये</h1>
        <ul className="pl-4 pr-4 pt-0 noListStyle mb-3">
          <li className="mb-2">
            १) फक्त कुंभार समाजासाठी गेल्या अनेक वर्षापासून विश्वसनीय कार्य.
          </li>
          <li className="mb-2">२) दरवर्षी 1००० नवीन स्थळांची नोंदणी.</li>
          <li className="mb-2">
            {" "}
            ३) नेमका ऑनलाईन सर्च- वेबसाईट/अपवर Search option मधून वय, उंची,
            मंगळ, शिक्षण, खाजगी/सरकारी नोकरी किंवा व्यवसाय ठिकाण, मूळ गाव,
            यासर्वांवरुन फोटोसह स्थळे शोधण्याची सुविधा.
          </li>
          <li className="mb-2">
            {" "}
            ४) वेबसाईट वरील GET CONTACT) मधून ईमेलने स्थळांची माहिती त्वरीत
            मिळते. (सब्स्क्रिबशन प्रमाणे स्थळे घेता येतील)
          </li>
          <li className="mb-2">
            {" "}
            ५) आपण घेतलेल्या स्थळांना आपला इंटरेस्ट ईमेलने /एसएमएस व्दारे
            पत्रिका गुण मिलना सहीत पाठविला जातो तसेच समोरील स्थळाकडून आपणास
            उत्तर मिळण्याची सोय.
          </li>
          <li className="mb-2">
            {" "}
            6) वेब /अँपवर लॉगिन नंतर दोन फोटो ठेवण्याची व बदलण्याची तसेच माहिती
            अपडेट करण्याची मोफत सोय.
          </li>
          <li className="mb-2">
            {" "}
            7) केंद्रात संपूर्ण महाराष्ट्रातील बहुसंख्य कुंभार उच्चशिक्षित स्थळे
            नोंदविली असल्यामुळे आपणांस इतर विवाह केंद्रात नांव नोंदविण्याची गरज
            नाही.
          </li>
          <li className="mb-2">
            {" "}
            8) आजपर्यंत हजारो लग्ने जमली. वेबसाईटवर SUCCESS STORIES बघावा.
          </li>
        </ul>
        <h1 className="font22px font-bold mb-1">केंद्राचे नियम व अटी</h1>
        <ul className="pl-4 pr-4 pt-0">
          <li className="mb-2">
            वधुवर केंद्र सूचक केंद्रात नाव नोंदणीसाठी खालीलप्रमाणे फी नाव नोंदणी
            करतान! सुरुवातील! भरावी लागते. सदर फी एक वर्षासाठी असते.
            <div className="bg-white p-2 row mb-2">
              <div className="col">
                <label className="d-block textDarkRed font16px font-bold">
                  अ.नं.
                </label>
                <label className="d-block font-bold">1</label>
              </div>
              <div className="col">
                <label className="d-block textDarkRed font16px font-bold">
                  नौींदणी फी तपशील
                </label>
                <label className="d-block font-bold">
                  वार्षिक नौींदणी फी / वार्षिक नोंदणी फी
                </label>
              </div>
              <div className="col">
                <label className="d-block textDarkRed font16px font-bold">
                  वार्षिक फी रुपये
                </label>
                <label className="d-block font-bold">1000 /- Rs</label>
              </div>
            </div>
            फी येबसाईटबरील UPI CODE द्वारे भरता येईल. किंवा आमच्य! बँकेच्या
            खात्यावर नेट बँकिंग /रोख्/UPI ID /QR CODE ने जमा करंता येईल.
            केंद्रात आल्यास फी रोखीने UPI ID/ QR CODE ने भरता येईल.
            <div className="bg-white p-2 mb-2 mt-2 row">
              <div className="col-sm-3 text-center">
                <label className="d-block textRed font16px font-bold">
                  Scan Code for Payment
                </label>
                <img alt="" className="m-auto" src={qr} />
              </div>
              <div className="pl-3 col-sm-8">
                <label className="d-block textRed font16px font-bold">
                  Account Details
                </label>
                <label className="d-block">
                  युनिव्हर्सल कन्सल्टन्सी सर्व्हिसेस स्टेट बँक ऑफ इंडिया
                </label>
                <label className="d-block">
                  अकाऊंट नंबर(ACCOUNT NO.) – 39923147776
                </label>
                <label className="d-block">
                  आय एफ एस सी कोड (IFSC CODE) : एस बी आय एन 0020786
                </label>
              </div>
            </div>
          </li>
          <li className="mb-2">
            या केंद्रात फि भरल्यानंतर आपल्या स्थळाची माहिती २४ तासात वेबसाईटवर
            टाकली जाईल.
          </li>
          <li className="mb-2">
            {" "}
            नांव नोंदणीसाठी केंद्राचा नोंदणी अर्ज www.kumbharmangalam.com या
            वेबसाईट वरून फोटोसह संपूर्णपणे भरुन पाठवा किंवा व्हाट्स अप वर
            संपूर्ण माहिती पाठवणे गरजेचे आहे.
          </li>
          <li className="mb-2">
            या केंद्रात फि भरल्यानंतर आपल्या स्थळाची माहिती २४ तासात वेबसाईटवर
            टाकली जाईल.
          </li>
          <li className="mb-2">
            {" "}
            एकदा भरलेली फि कोणत्याही सबबीवर परत मिळणार नाही.
          </li>
          <li className="mb-2">
            नांव नोंदणी केल्यानंतर आपणास अनुरूप असणाऱ्या स्थळांशी संपर्क
            करण्यासाठी वेबसाईटवरील GET CONTACT ऑप्शनमध्ये आपण निवडलेल्या
            स्थळांचे नांव, पत्ता, मोबाईल नंबर, ई मेल इत्यादी माहिती आपणास त्वरीत
            मिळते.
          </li>
          <li className="mb-2">
            वेबसाईट वरील शोध या ऑप्शन मधून वर किंवा वधू हे ऑप्शन क्लीक
            केल्यानंतर वर किंवा वधूचे रजिस्टर नंबर येतील. रजिस्टर नंबरवर क्लीक
            करताच स्थळाची वय, उंची, शिक्षण, फोटो, नोकरी किंवा व्यवसायाचे ठिकाण,
            मूळगांव, सध्या रहाण्याचे ठिकाण, नातेवाईक, अपेक्षा, मंगळासह सर्व
            माहिते मिळते.
          </li>
          <li className="mb-2">
            केंद्रातून एका सभासदाला त्यांचे स्थळाला मॅच होणारे दररोज पाच
            बायोडाटा घेता येतील.
          </li>
          <li className="mb-2">
            केंद्रातून एका सभासदाला दररोज त्यांचे स्थळाला मॅच होणारे बायोडाटा
            सब्स्क्रिबशन प्रमाणे स्थळे घेता येतील.
          </li>
          <li className="mb-2">
            वेब /अँपवर लॉगिन नंतर दोन फोटो ठेवण्याची व बदलण्याची तसेच माहिती
            अपडेट करण्याची मोफत सोय. आपल्या इतर माहितीमध्ये काही बदल करावयाचा
            असल्यास लॉगिन नंतर प्रोफाइल मधून एडिट ऑपशन ने बदलता येतील.
          </li>
          <li className="mb-2">
            विवाहयोग केंद्रातर्फे किंवा स्वप्रयत्नाने जुळुन आल्यावर त्या संबधीची
            माहीती केंद्रास ई मेलने कळवावी.{" "}
          </li>
          <li className="mb-2">
            आपण घेतलेल्या स्थळाच्या माहितीची खातरजमा तुमचा रिजनल कुंभार
            पदाधिकाऱ्याकडून,आपले नातलग, मित्रमंडळी यांचे मार्फत स्वतः करून
            घ्यावी.{" "}
          </li>
          <li className="mb-2">
            नांव नोंदणी नंतर विवाह अमुक दिवसात जमेल याची खात्री देता येणार नाही.{" "}
          </li>
          <li className="mb-2">
            केंद्रातुन घेतलेल्या माहितीचा कोणीही गैरवापर करू नये. गैरवापर
            केल्याचे आढळल्यास संबधीत सभासदाचे सभासदत्व त्वरीत रद्द केले जाईल.
          </li>
        </ul>
      </section>
      <FooterComponent />
    </>
  );
};

export default Terms;
